import { render } from "./ChooseRoomTypeModal.vue?vue&type=template&id=44321c29&ts=true"
import script from "./ChooseRoomTypeModal.vue?vue&type=script&lang=ts"
export * from "./ChooseRoomTypeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__